export interface GetIdleReportListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetIdleReportListPagingAndFilterResponseData
}

export interface GetIdleReportListPagingAndFilterResponseData {
    totalRecordCount: number
    items: GetIdleReportListPagingAndFilterResponseItem[]
}

export interface GetIdleReportListPagingAndFilterResponseItem {
    date: string
    plate: string
    driverNameSurname: string
    idleStartTime: string
    idleEndTime: string
    idleStartLocation: string
    deviceId: string
    driverRfid: any
}

export const initialGetIdleReportListPagingAndFilterResponseData: GetIdleReportListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}